import InviteContactsForm from './InviteContactsForm.component';

export default InviteContactsForm;